import React, { useContext } from 'react';
import Header from "src/components/common/Header";
import Confirm from 'src/components/project/ProjectConfirm';
import { MenuContext } from 'src/context/MenuContext';
import Menu from "src/components/common/Menu";
import { useParams } from "react-router-dom";
import ScrollTop from 'src/components/common/ScrollTop';

const ProjectConfirm = () => {
    const { visibleMenu } = useContext(MenuContext);
    const { id } = useParams();
    return (
        <React.Fragment>
            {visibleMenu && <Menu />}
            <div className={visibleMenu ? 'menu-open' : 'menu-closed'}>
                <Header sx={{ mb: 500 }} />
                <Confirm id={id} />
            </div>
            <ScrollTop />
        </React.Fragment>
    );
};

export default ProjectConfirm;